import { Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { IInvestorTransaction } from '~/@api/generated-api-types/global.types'
import ArrowTransactionSvg from '~/@ui/_sharedSvgs/ui/ArrowTransaction.svg?react'
import { useAlert } from '~/@ui/alert/useAlert'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'

export const TransactionsTab = () => {
  const { showAlert } = useAlert()

  const [transactions, setTransactions] = useState<
    IInvestorTransaction[] | null
  >(null)

  const getInvestments = async () => {
    try {
      const { data: response } =
        await getApi().investorTransactionsAppApiControllerGetInvestorTransactionsAndCount()

      if ('success' in response) {
        setTransactions(response.data)
        return
      }

      throw new Error('Nasatala neznáma chyba pri načítavaní transakcií.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  useEffect(() => {
    getInvestments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return transactions && transactions.length > 0 ? (
    <Stack className="px-6 pt-8">
      <Typography className="text-base font-bold text-zBlack200">
        História transakcií
      </Typography>

      <Stack className="gap-2 pt-4">
        {transactions.map((trans) => (
          <Stack key={trans.id} className="p-4 bg-zGrey200 rounded-4d">
            <Stack className="flex-row justify-between pr-4">
              <Typography className="text-xs font-medium text-zGrey400">
                {`ID transakcie: ${trans.id.replace(/[^0-9]/g, '')}`}
              </Typography>
              <Typography className="text-xs font-medium text-zGrey400">
                {new Date(trans.createdAt).toLocaleDateString('sk-SK')}
              </Typography>
            </Stack>

            <Stack className="gap-1 pt-2">
              <Typography className="text-3d font-medium text-zGrey300">
                {trans.type}
              </Typography>
              <Stack className="flex-row items-center gap-1.5">
                <Typography className="text-xl font-bold text-zBlack200 tabular-nums">
                  {`${Math.floor(trans.amount).toLocaleString('sk-SK')} €`}
                </Typography>
                <ArrowTransactionSvg className="mr-auto" />
                <Typography className="text-xs font-semibold text-zGrey300">
                  {trans.senderIBAN}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  ) : (
    <Stack className="px-6 pt-8">
      <Typography className="text-3d font-medium text-zGrey400 text-center">
        Nemáte žiadne transakcie.
      </Typography>
    </Stack>
  )
}
